
(function(window, document, $, undefined){

    'use strict';
    window.main = {};

    main.init = function() {
        main.carousel();
        main.translatorButton();
        main.translatorReorder();
        main.textResizer();
        main.removeEmptyLinksFromMobile();
    }

    main.removeEmptyLinksFromMobile = function() {

        setTimeout(() => {

            $('a[href="#mobile-menu-menu-2"], a:not([href])').each(function () {
                const $link = $(this);

                if (!$link.attr('href') || $link.attr('href') === '') {
                    $link.attr('href', '#');
                    $link.attr('role', 'button');
                }
            });

        }, 800);

    }


    main.textResizer = function() {

        // Retrieve saved font size from local storage
        var savedFontSize = localStorage.getItem("fontSize");
        if (savedFontSize) {
            $("html").css("font-size", savedFontSize + "px");
            $("select.text-resizer").val(savedFontSize); // Set the select value
        }

        $("select.text-resizer").change(function() {
            var fontSize = $(this).val();
            $("html").css("font-size", fontSize + "px");
            localStorage.setItem("fontSize", fontSize); // Save to local storage
        });

        $(".text-resizer-btn").click(function(e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent click event from propagating to document

            let content = $(".text-resizer-content");

            if (content.hasClass("active")) {
                content.animate({ opacity: 0 }, 250, function() {
                    content.removeClass("active").css({ display: "none" });
                });
            } else {
                content.css({ display: "flex", opacity: 0 }).addClass("active").animate({ opacity: 1 }, 250);
            }
        });

        // Click outside to fade out
        $(document).click(function(e) {
            let content = $(".text-resizer-content");

            if (content.hasClass("active") && !content.is(e.target) && content.has(e.target).length === 0) {
                content.animate({ opacity: 0 }, 250, function() {
                    content.removeClass("active").css({ display: "none" });
                });
            }
        });

    }

    main.carousel =  function() {

        let columnCount = $('#homepage-carousel > .fusion-builder-row').children().length;;

        if (columnCount > 3 || $( "html" ).hasClass( "ua-mobile" )) {

            let $carousel = $('#homepage-carousel > .fusion-builder-row');

            $carousel.on( 'ready.flickity', function() {

                setTimeout(() => {
                    setEqualHeight();
                }, '1000');
            });

            $carousel.flickity({
                cellAlign: 'left',
                contain: true,
                wrapAround: true
            });

            function setEqualHeight() {
                var maxHeight = 0;
                let viewport = $('.flickity-viewport');

                $('#homepage-carousel .fusion-column-wrapper').each(function () {
                    var height = $(this).outerHeight();
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });
                $('#homepage-carousel .fusion-column-wrapper').outerHeight(maxHeight);
                //viewport.outerHeight(maxHeight + 44);
            }
        }
    }

    main.translatorButton = function(){

        /*$(".translator-btn").click(function() {
            $(".translator-content").animate({ width: 'toggle' });
        });*/

        $(".translator-btn").click(function(e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent click event from propagating to document

            let content = $(".translator-content");

            if (content.hasClass("active")) {
                content.animate({ opacity: 0 }, 250, function() {
                    content.removeClass("active").css({ display: "none" });
                });
            } else {
                content.css({ display: "flex", opacity: 0 }).addClass("active").animate({ opacity: 1 }, 250);
            }
        });

        // Click outside to fade out
        $(document).click(function(e) {
            let content = $(".translator-content");

            if (content.hasClass("active") && !content.is(e.target) && content.has(e.target).length === 0) {
                content.animate({ opacity: 0 }, 250, function() {
                    content.removeClass("active").css({ display: "none" });
                });
            }
        });
    }

    main.translatorReorder = function(){

        setTimeout(() => {

            var $dropdown = $('.goog-te-combo');

            if ($dropdown.length) {


                reset();

                $dropdown.on( "change", function() {

                    let value = $dropdown.val();
                    let selectedIndex = $dropdown.prop("selectedIndex");
                    localStorage.setItem("languageDropdownSelected", selectedIndex);

                    reset();

                    var selectedText = $dropdown.find("option:selected").text();
                    console.log(selectedText);
                    console.log(value);


                } );
            }
        }, "750");


        function reset() {

                var $dropdown = $('.goog-te-combo');

                var options = $dropdown.find('option').toArray();

                options.sort(function (a, b) {

                    /*var preferred = [
                        'Select Language',
                        'Spanish',
                        ];*/
                    var preferred = [
                        'Select Language',
                        'English',
                        'Spanish',
                        'Portuguese (Brazil)',
                        'Chinese (Simplified)',
                        'Chinese (Traditional)',
                        'Haitian Creole',
                        'Arabic',
                        'French',
                        'Vietnamese',
                        'Hindi',
                        'Russian',
                        'Italian',
                        'Swahili',
                        'Khmer',
                        'Yoruba',
                        'Igbo',
                        'Greek',
                        'Korean',
                        'Telugu',
                        'German',
                        'Polish',
                        'Amharic',
                        'Somali',
                        'Tamil',
                        'Ukrainian',
                        'Nepali',
                        'Marathi',
                        'Gujarati',
                        'Persian',
                        'Hebrew',
                        'Urdu',
                        'Filipino',
                        'Thai',
                        'Lao',
                        'Japanese',
                        'Bengali',
                        'Malayalam',
                        'Kannada',
                        'Armenian',
                        'Punjabi',
                    ];
                    var textA = $(a).text();
                    var textB = $(b).text();

                    var indexA = preferred.indexOf(textA);
                    var indexB = preferred.indexOf(textB);

                    if (indexA !== -1 && indexB !== -1) {
                        return indexA - indexB; // Custom order
                    } else if (indexA !== -1) {
                        return -1; // Preferred languages first
                    } else if (indexB !== -1) {
                        return 1;
                    }
                    return textA.localeCompare(textB);
                });

            /*

            console.log("Selected index: " + selectedIndex);

            */

            var selectedValue = $dropdown.val();
            if (selectedValue === 'Selected Language') {
                //$dropdown.prop("selectedIndex", 0);
                //$dropdown.val("en").trigger("change");
                console.log('selected language selected');
            }

            var selectedIndex = $dropdown.prop("selectedIndex");

            setTimeout(() => {

                let newOptions = [
                    { "text": "English", "value": "en" },
                    { "text": "Spanish", "value": "es" },
                    { "text": "Portuguese (Brazil)", "value": "pt" },
                    { "text": "Chinese (Simplified)", "value": "zh-CN" },
                    { "text": "Chinese (Traditional)", "value": "zh-TW" },
                    { "text": "Haitian Creole", "value": "ht" },
                    { "text": "Arabic", "value": "ar" },
                    { "text": "French", "value": "fr" },
                    { "text": "Vietnamese", "value": "vi" },
                    { "text": "Hindi", "value": "hi" },
                    { "text": "Russian", "value": "ru" },
                    { "text": "Italian", "value": "it" },
                    { "text": "Swahili", "value": "sw" },
                    { "text": "Khmer", "value": "km" },
                    { "text": "Yoruba", "value": "yo" },
                    { "text": "Igbo", "value": "ig" },
                    { "text": "Greek", "value": "el" },
                    { "text": "Korean", "value": "ko" },
                    { "text": "Telugu", "value": "te" },
                    { "text": "German", "value": "de" },
                    { "text": "Polish", "value": "pl" },
                    { "text": "Amharic", "value": "am" },
                    { "text": "Somali", "value": "so" },
                    { "text": "Tamil", "value": "ta" },
                    { "text": "Ukrainian", "value": "uk" },
                    { "text": "Nepali", "value": "ne" },
                    { "text": "Marathi", "value": "mr" },
                    { "text": "Gujarati", "value": "gu" },
                    { "text": "Persian", "value": "fa" },
                    { "text": "Hebrew", "value": "iw" },
                    { "text": "Urdu", "value": "ur" },
                    { "text": "Filipino", "value": "tl" },
                    { "text": "Thai", "value": "th" },
                    { "text": "Lao", "value": "lo" },
                    { "text": "Japanese", "value": "ja" },
                    { "text": "Bengali", "value": "bn" },
                    { "text": "Malayalam", "value": "ml" },
                    { "text": "Kannada", "value": "kn" },
                    { "text": "Armenian", "value": "hy" },
                    { "text": "Punjabi", "value": "pa" }
                ];

                // Remove all existing options
                $dropdown.empty();

                // Append new options
                $.each(newOptions, function(index, option) {
                    $dropdown.append($('<option>', {
                        value: option.value,
                        text: option.text
                    }));
                });

                const languageSelected = localStorage.getItem("languageDropdownSelected");

                if (languageSelected) {
                    $dropdown.prop("selectedIndex", languageSelected);
                } else {
                    $dropdown.prop("selectedIndex", selectedIndex);
                }



                /*$dropdown.find("option").filter(function() {
                    return $(this).text() === "Select Language"; // Replace with the text
                }).remove();

                $dropdown.empty().append(options);
                $dropdown.prop("selectedIndex", selectedIndex);*/

                //$dropdown.val('');

            }, "200");
        }
    }

    $(document).on( 'ready', main.init );


})(window, document, jQuery);